import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Meeting } from '../../../../shared/src/types/Meeting';

interface MeetingState {
    meetingsByDay: Meeting[];
    meetingsByMonth: Meeting[];
}

const initialState: MeetingState = {
    meetingsByDay: [],
    meetingsByMonth: [],
};

const calendarSlice = createSlice({
    name: 'calendar',
    initialState,
    reducers: {
        setMeetingsForToday(state, action: PayloadAction<Meeting[]>) {
            state.meetingsByDay = action.payload;
        },
        setMeetingsForMonth(state, action: PayloadAction<Meeting[]>) {
            state.meetingsByMonth = action.payload;
        },
        addMeeting(state,action:PayloadAction<Meeting>){
            state.meetingsByMonth.push(action.payload)
        }
    },
});

export const {
    setMeetingsForToday,
    setMeetingsForMonth,
    addMeeting
} = calendarSlice.actions;

export const selectMeetingsForToday = (state: { calendar: MeetingState }): Meeting[] =>
    state.calendar.meetingsByDay;


export const selectMeetingsForMonth = (state: { calendar: MeetingState }): Meeting[] =>
    state.calendar.meetingsByMonth;

export default calendarSlice.reducer;
